import * as actionTypes from '../actions/actionTypes';
const initialState = { uid: null, email: '', isLogged: false, userType: '', isAdmin: false, displayName: null };

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_SIGN_IN:
            {
                return {
                    ...state,
                    uid: action.uid,
                    isLogged: action.isLogged,
                    email: action.email,
                    isAdmin: action.isAdmin,
                    userType: action.userType,
                    displayName: action.displayName
                }
            }
        case actionTypes.AUTH_SIGN_OUT:
            {
                return {
                    ...state,
                    uid: null,
                    email: null,
                    isLogged: false,
                    isAdmin: false,
                    userType: null,
                    displayName: null
                }
            }
        default:
            {
                return state
            }
    }
}

export default authReducer;